import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import type { ShellChrome } from "@/layouts/shellChrome";

/**
 * THE ACCOUNTANT'S PHONE STRIP — "‹ Accounts ▸ Bills & claims · Aug", as the
 * lane's phone boards draw it. Spread into a fallback page's chrome; the desk
 * bar is untouched, and a phone has no search on these screens.
 */
export function useAccountsCrumb(
  crumb: string,
  title: ReactNode,
  back = "/accountant",
): Pick<
  ShellChrome,
  "phoneCrumb" | "phoneTitle" | "onPhoneBack" | "phoneSearch"
> {
  const go = useNavigate();
  return {
    phoneCrumb: crumb,
    phoneTitle: title,
    onPhoneBack: () => go(back),
    phoneSearch: false,
  };
}
